var map = {
	"./China.png": 9648,
	"./France.png": 4755,
	"./Germany.png": 7793,
	"./Japan.png": 6965,
	"./Korea.png": 14,
	"./Russia.png": 8845,
	"./UK.png": 5129,
	"./USA.png": 589
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3298;